module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "row",
      "width": "100%",
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "design-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.orderDetail.servOrderRpd.designActiveImg
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "design-info"
  }, [_c('div', {
    staticClass: "order-input-wrap"
  }, [_c('base-tag', {
    attrs: {
      "label": "基本信息"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n            " + _vm._s(_vm.orderDetail.demContact) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n            " + _vm._s(_vm.orderDetail.demPhone) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n            " + _vm._s(_vm.orderDetail.demPatient) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n            " + _vm._s(_vm.orderDetail.demSex == '00' ? '男' : '女') + "\n          ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "order-input-wrap"
  }, [_c('base-tag', {
    attrs: {
      "label": "设计费详情"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n            " + _vm._s(_vm.orderDetail.orderCount) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n            " + _vm._s(_vm.parseMoney(_vm.orderDetail.orderPrice)) + " 元\n          ")])]), _vm._v(" "), (_vm.orderDetail.servOrderRpd.steelCount) ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n            " + _vm._s(_vm.orderDetail.servOrderRpd.steelCount) + "\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.servOrderRpd.steelCount) ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n            " + _vm._s(_vm.parseMoney(_vm.orderDetail.servOrderRpd.steelPrice)) + " 元\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.servOrderRpd.glueCount) ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n            " + _vm._s(_vm.orderDetail.servOrderRpd.glueCount) + "\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.servOrderRpd.glueCount) ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n            " + _vm._s(_vm.parseMoney(_vm.orderDetail.servOrderRpd.gluePrice)) + " 元\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.servOrderRpd.enclosureCount) ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n            " + _vm._s(_vm.orderDetail.servOrderRpd.enclosureCount) + "\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.servOrderRpd.enclosureCount) ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n            " + _vm._s(_vm.parseMoney(_vm.orderDetail.servOrderRpd.enclosurePrice)) + " 元\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.orderRushFee != 0) ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n            " + _vm._s(_vm.parseMoney(_vm.orderDetail.orderRushFee)) + "\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.isEditScanModel == '1') ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n            " + _vm._s(_vm.parseMoney(_vm.common.serv.get(_vm.orderDetail.servCataId).editScanModelBprice)) + " 元\n          ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n            " + _vm._s(_vm.parseMoney(_vm.orderDetail.orderAmount)) + " 元\n          ")])])], 1), _vm._v(" "), (_vm.isDesign) ? _c('div', {
    staticClass: "order-input-wrap"
  }, [_c('base-tag', {
    attrs: {
      "label": "设计需求"
    }
  }), _vm._v(" "), (_vm.orderDetail.servOrderRpd.designTray) ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n            " + _vm._s(_vm.showStr(_vm.orderDetail.servOrderRpd.designTray)) + "\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.servOrderRpd.enclosure) ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n            " + _vm._s(_vm.orderDetail.servOrderRpd.enclosure) + "\n          ")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "order-input-wrap"
  }, [_c('base-tag', {
    attrs: {
      "label": "备注信息"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-textarea"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 20
      },
      "disabled": "",
      "readonly": ""
    },
    model: {
      value: (_vm.orderDetail.orderRemark),
      callback: function($$v) {
        _vm.$set(_vm.orderDetail, "orderRemark", $$v)
      },
      expression: "orderDetail.orderRemark"
    }
  })], 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("下单名称：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("联系方式：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("患者姓名：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("患者性别：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("数量：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("单价：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("钢牙数量：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("钢牙单价：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("充胶牙数量：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("充胶牙单价：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("精密附件数量：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("精密附件单价：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("加急费：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("口扫模型编辑：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("总价：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("下单类型：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("精密附件：")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a4c49242","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Order/activeModification/activeDetail.vue
// module id = 668
// module chunks = 0